import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { Paragraph, colors } from '@fs/zion-ui'
import PropTypes from 'prop-types'

const coverCss = css`
  text-transform: uppercase;
  position: absolute;
  height: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  color: ${colors.gray100};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  backdrop-filter: brightness(50%);

  & p {
    padding: 0;
  }

  & h4 {
    padding-top: 0;
  }
`

export default function ViewAllCover({ viewAllCount, size }) {
  const [t] = useTranslation()
  return (
    // Aria hidden because MemoryTile aria label handles "view all" for screen readers
    <div className={coverCss} centered="true" aria-hidden>
      {size === 'lg' ? (
        <>
          +{viewAllCount}
          <Paragraph centered size="sm">
            {t('memory-tile.view-all')}
          </Paragraph>
        </>
      ) : (
        <Paragraph centered>+{viewAllCount}</Paragraph>
      )}
    </div>
  )
}

ViewAllCover.propTypes = {
  /** Number to display n the "View All" text. */
  viewAllCount: PropTypes.number,

  /** Size of the tile. No 'md' size, in the case we add one in the future. */
  size: PropTypes.oneOf(['sm', 'lg']),
}
